import React from 'react';
import PartnerSlider from './components/PartnerSlider';
import OwlCarouselBanner from './components/OwlCarouselBanner';


const About = () => {
  return (
    <>
      <section className="about-section inner-page">
        <div className="container">
          <h1>Our Work</h1>
          <p>
            Welcome to our company! We are dedicated to providing top-quality
            services and solutions to our customers.

            <PartnerSlider/>
          
          </p>
        </div>
      </section>
   
      <section className="space-bottom overflow-hidden" id="service-sec">
        <div
          className="service-wrap1 space th-radius overflow-hidden"
          style={{
            backgroundImage: `url('/assets/img/bg/gray-bg2.png')`,
            backgroundColor: 'rgba(128, 128, 128, 0.5)', // Replace with your overlay and opacity styling
          }}
        >
          <div className="shape-mockup service-bg-shape1-5 d-xxl-inline-block d-none z-index-3 spin">
            <img src="/assets/img/shape/service_shape2_1.png" alt="Shape 1" />
          </div>
          <div className="shape-mockup service-bg-shape1-6 d-xxl-inline-block d-none z-index-3 jump">
            <img src="/assets/img/shape/service_shape2_2.png" alt="Shape 2" />
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="title-area text-center">
                  <span className="sub-title">Charity Services</span>
                  <h2 className="sec-title">
                    We Do it for all People Humanist Services
                  </h2>
                </div>
              </div>
            </div>
            <div className="row gy-30 gx-30 justify-content-center">
              <div className="col-xl-4 col-md-6">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src="/assets/img/service/service_card_1_1.png"
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src="/assets/img/service/service_card_1_1.png"
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-md-6">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src="/assets/img/service/service_card_1_1.png"
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-md-6">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src="/assets/img/service/service_card_1_1.png"
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
              {/* Repeat for other service cards */}
            </div>
          </div>
        </div>
      </section>
      <OwlCarouselBanner/>
    </>
  );
};

export default About;
